<template>
  <div class="border-t border-gray-800 mt-12 pt-8 text-center text-sm">
    <p>© {{ currentYear }} AutoVolt.ai - {{ tx.direitos }}</p>
  </div>
</template>

<script setup lang="ts">
import { useTextos } from '../../i18n/idioma'

const tx = useTextos({
  pt: { direitos: 'Todos os direitos reservados' },
  en: { direitos: 'All rights reserved' },
  es: { direitos: 'Todos los derechos reservados' },
})
const currentYear = new Date().getFullYear()
</script>